
import { useLoadScript } from "@react-google-maps/api";
import { useState, useEffect } from "react";

const libraries: ("geometry" | "places")[] = ["geometry", "places"]; // Define outside to keep it constant

export function useGoogleMapsLoader() {
  const [loaded, setLoaded] = useState<{ isLoaded: boolean; loadError?: Error | undefined }>({ isLoaded: false });

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY ?? "", // Replace with your API key
    libraries, // Use the constant libraries array
  });

  useEffect(() => {
    if (isLoaded || loadError) {
      setLoaded({ isLoaded, loadError });
    }
  }, [isLoaded, loadError]);

  return loaded;
}